module.exports = __webpack_public_path__ + "img/health-ai.3ca15da6.gif";